import { Close } from "@mui/icons-material";
import { IconButton, Stack, Typography } from "@mui/material";

interface Props {
  onClose: () => void;
}

const PanelHeader = ({ onClose }: Props) => {
  return (
    <Stack gap={1}>
      <Stack
        direction={"row"}
        gap={1.5}
        justifyContent="space-between"
        sx={{
          background: "linear-gradient(135deg, #00b6b9 0%, #00fbff 100%)",
          color: "common.white",
          p: 2,
        }}
      >
        <Typography variant="h5">Vida</Typography>
        <IconButton onClick={onClose}>
          <Close />
        </IconButton>
      </Stack>
      <Typography alignSelf={"center"} variant="subtitle1">
        Ask me anything, I'll be your savior
      </Typography>
    </Stack>
  );
};

export default PanelHeader;
